import { InjectionToken } from '@angular/core';
import { ErrorHandlerConfig } from '../models/error-handler-config.interface';

export const ErrorHandlerConfigToken = new InjectionToken<ErrorHandlerConfig>('ErrorHandlerConfig');
